<template>
  <div class="back" :style="`${isBackDisabled ? 'display: none' : ''}`" @click="go_back" @touchstart.stop="startDrag">
    <img v-if="!isKunhua" src="/static/img/tip.png" alt="" />
    <img v-else src="/static/img/tip_kunhua.png" alt="" />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
const hideBackRoutes = ['/cspg']
export default {
  data() {
    return {
      initialTop: '',
      isMiniProgram: localStorage.getItem('is_wx') === '1'
    }
  },
  computed: {
    isBackDisabled() {
      return this.isMiniProgram || hideBackRoutes.some(route => this.$route.path.startsWith(route))
    },
    isKunhua() {
      return this.$route.path.startsWith('/kunhua_physicalExamination')
    }
  },
  mounted() {
    this.initialTop = this.$el.offsetTop
    console.log('router history', this.$router)
  },
  methods: {
    go_back() {
      const isMiniProgram = localStorage.getItem('is_wx') === '1'
      if (isMiniProgram && this.$router.history._startLocation === this.$router.history.current.fullPath) {
        wx.miniProgram.navigateBack()
      } else {
        this.$router.back()
      }
    },
    startDrag(event) {
      let startY = event.clientY || event.touches[0].clientY
      let element = this.$el
      let initialTop = element.offsetTop
      let maxTop = 0 // 最上不能超过的位置
      let minTop = this.initialTop // 最下不能超过的位置

      const handleMouseMove = (e) => {
        let currentY = e.clientY || e.touches[0].clientY
        let deltaY = currentY - startY
        let newTop = initialTop + deltaY

        // 添加限制条件
        if (newTop < maxTop) {
          newTop = maxTop
        }
        if (newTop > minTop) {
          newTop = minTop
        }

        element.style.top = newTop + 'px'
      }

      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
        document.removeEventListener('touchmove', handleMouseMove)
        document.removeEventListener('touchend', handleMouseUp)
      }

      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
      document.addEventListener('touchmove', handleMouseMove)
      document.addEventListener('touchend', handleMouseUp)
    }
  }
}
</script>

<style scoped lang="less">
.back {
  width: 0.8rem;
  height: 2.2rem;
  position: fixed;
  z-index: 1000;
  right: 0;
  bottom: 2rem;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
